/*
  Rohrlaengen-Auswahl + Rechner fuer Wild Flame Deckenkamine.
  Arbeitet komplett mit Event-Delegation, damit auch per AJAX nachgeladene
  Produkt-Formulare (Quick-Shop-Modal) ohne Re-Initialisierung funktionieren.
  Gehoert zu snippets/bek-rohrlaenge.liquid.
*/
(function () {
  'use strict';

  if (window.__bekRohrInit) return; // doppelte Initialisierung verhindern
  window.__bekRohrInit = true;

  var SEL = {
    wrap: '[data-bek-rohr]',
    length: '[data-bek-length]',
    fallback: '[data-bek-fallback]',
    unklar: '[data-bek-unklar]',
    adapterNote: '[data-bek-adapter-note]',
    modal: '[data-bek-modal]',
    open: '[data-bek-open]',
    close: '[data-bek-close]',
    apply: '[data-bek-apply]',
    direct: '[data-bek-direct]',
    decke: '[data-bek-decke]',
    hoehe: '[data-bek-hoehe]',
    result: '[data-bek-result]',
    msg: '[data-bek-msg]'
  };

  function num(v) {
    if (v === null || v === undefined || String(v).trim() === '') return NaN;
    return parseFloat(String(v).replace(',', '.'));
  }

  function wrapFor(el) {
    var wrap = el.closest(SEL.wrap);
    if (wrap) return wrap;
    var modal = el.closest(SEL.modal);
    if (modal && modal.dataset.bekOwner) {
      return document.getElementById(modal.dataset.bekOwner);
    }
    return null;
  }

  function modalFor(wrap) {
    return document.querySelector(SEL.modal + '[data-bek-owner="' + wrap.id + '"]');
  }

  function conf(wrap) {
    return {
      basis: num(wrap.dataset.basis),
      puffer: num(wrap.dataset.puffer),
      min: num(wrap.dataset.min),
      max: num(wrap.dataset.max),
      inkl: num(wrap.dataset.inkl),
      adapterVariant: wrap.dataset.adapterVariant,
      adapterPrice: num(wrap.dataset.adapterPrice),
      adapterAvailable: wrap.dataset.adapterAvailable === 'true',
      currency: wrap.dataset.currency,
      locale: wrap.dataset.locale
    };
  }

  // Anzahl benoetigter Verlaengerungs-Sets: 201-400cm -> 1, 401-600cm -> 2
  function adapterQty(c, val) {
    if (!isFinite(val) || val <= c.inkl) return 0;
    return Math.ceil((val - c.inkl) / 200);
  }

  function formWrap(form) {
    return Array.from(document.querySelectorAll(SEL.wrap)).find(function (wrap) {
      var input = wrap.querySelector(SEL.length);
      return input && input.form === form;
    });
  }

  function fireplaceQuantity(wrap) {
    var input = wrap.querySelector(SEL.length);
    var quantity = input && input.form && input.form.elements.namedItem('quantity');
    return quantity ? Number(quantity.value) : 1;
  }

  function adapterReady(c) {
    return /^\d+$/.test(c.adapterVariant || '') && c.adapterAvailable &&
      Number.isSafeInteger(c.adapterPrice) && c.adapterPrice >= 0 && !!c.currency;
  }

  function adapterText(c, val, quantity) {
    if (!adapterReady(c)) return 'Die benötigte Rohrverlängerung ist derzeit nicht bestellbar. Bitte kontaktieren Sie uns zur Abstimmung.';
    if (!Number.isSafeInteger(quantity) || quantity < 1) return 'Bitte wählen Sie eine gültige Kaminmenge.';
    var perUnit = adapterQty(c, val);
    var count = perUnit * quantity;
    var price;
    try {
      price = new Intl.NumberFormat(c.locale || 'de', { style: 'currency', currency: c.currency }).format(count * c.adapterPrice / 100);
    } catch (error) {
      return 'Der Preis der Rohrverlängerung konnte nicht angezeigt werden. Bitte laden Sie die Seite neu.';
    }
    return perUnit + (perUnit === 1 ? ' Verlängerungsset je Kamin' : ' Verlängerungssets je Kamin') +
      ': ' + count + (count === 1 ? ' Set' : ' Sets') + ' für ' + quantity +
      (quantity === 1 ? ' Kamin' : ' Kamine') + '. Aufpreis insgesamt ' + price + '. Wird mitbestellt.';
  }

  /* ---------- Zustand Hauptfeld ---------- */

  function updateState(wrap) {
    var c = conf(wrap);
    var input = wrap.querySelector(SEL.length);
    var note = wrap.querySelector(SEL.adapterNote);
    var unklar = wrap.querySelector(SEL.unklar);
    var val = num(input && input.value);
    if (note) {
      var show = unklar && !unklar.checked && val > c.inkl && val <= c.max;
      note.hidden = !show;
      if (show) {
        var txt = note.querySelector('[data-bek-adapter-text]');
        if (txt) txt.textContent = adapterText(c, val, fireplaceQuantity(wrap));
      }
    }
  }

  function toggleUnklar(wrap, checked) {
    var input = wrap.querySelector(SEL.length);
    var fallback = wrap.querySelector(SEL.fallback);
    if (input) input.disabled = checked;
    if (fallback) fallback.disabled = !checked;
    wrap.classList.toggle('is-unklar', checked);
    updateState(wrap);
  }

  /* ---------- Popup ---------- */

  function openModal(wrap, opener) {
    var modal = modalFor(wrap);
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal); // raus aus transformierten Ahnen (AOS etc.)
    }
    modal.bekOpener = opener;
    if (opener) opener.setAttribute('aria-expanded', 'true');
    var input = wrap.querySelector(SEL.length);
    var direct = modal.querySelector(SEL.direct);
    if (direct && input && input.value) direct.value = input.value;
    modal.hidden = false;
    document.documentElement.classList.add('bek-rohr-modal-open');
    recalc(wrap, modal);
    var first = modal.querySelector(SEL.direct);
    if (first) first.focus({ preventScroll: true });
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.classList.remove('bek-rohr-modal-open');
    var opener = modal.bekOpener;
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (opener.isConnected) opener.focus({ preventScroll: true });
    }
  }

  function showMsg(modal, text, isError) {
    var msg = modal.querySelector(SEL.msg);
    if (!msg) return;
    if (!text) { msg.hidden = true; return; }
    msg.hidden = false;
    msg.textContent = text;
    msg.classList.toggle('is-error', !!isError);
  }

  function recalc(wrap, modal) {
    var c = conf(wrap);
    var decke = num(modal.querySelector(SEL.decke) && modal.querySelector(SEL.decke).value);
    var hoehe = num(modal.querySelector(SEL.hoehe) && modal.querySelector(SEL.hoehe).value);
    var resultField = modal.querySelector(SEL.result);
    var applyBtn = modal.querySelector('[data-bek-apply="calc"]');

    if (isNaN(decke) || isNaN(hoehe)) {
      if (resultField) resultField.value = '–';
      if (applyBtn) applyBtn.disabled = true;
      showMsg(modal, '');
      return;
    }

    var raw = decke - hoehe - c.basis + c.puffer;
    var rohr = Math.round(raw);
    if (resultField) resultField.value = isFinite(rohr) ? rohr : '–';

    if (!isFinite(rohr) || rohr < c.min) {
      if (applyBtn) applyBtn.disabled = true;
      showMsg(modal, 'Die berechnete Rohrlänge ist zu kurz (Minimum ' + c.min + 'cm). Bitte prüfen Sie Ihre Eingaben – oder kontaktieren Sie uns, wir beraten Sie gerne.', true);
      return;
    }
    if (rohr > c.max) {
      if (applyBtn) applyBtn.disabled = true;
      showMsg(modal, 'Die berechnete Rohrlänge liegt über ' + c.max + 'cm. Bitte nehmen Sie Kontakt mit uns auf – wir finden eine Lösung.', true);
      return;
    }
    if (applyBtn) applyBtn.disabled = false;
    if (rohr > c.inkl) {
      showMsg(modal, adapterText(c, rohr, fireplaceQuantity(wrap)), false);
    } else {
      showMsg(modal, '');
    }
  }

  function applyValue(wrap, modal, mode) {
    var c = conf(wrap);
    var val;
    if (mode === 'direct') {
      val = num(modal.querySelector(SEL.direct) && modal.querySelector(SEL.direct).value);
      if (!isFinite(val)) {
        showMsg(modal, 'Bitte tragen Sie eine Rohrlänge in cm ein.', true);
        return;
      }
      if (!Number.isInteger(val)) {
        showMsg(modal, 'Bitte tragen Sie die Rohrlänge in ganzen Zentimetern ein.', true);
        return;
      }
      if (val < c.min || val > c.max) {
        showMsg(modal, 'Bitte eine Länge zwischen ' + c.min + ' und ' + c.max + 'cm eintragen. Für Längen über ' + c.max + 'cm kontaktieren Sie uns bitte.', true);
        return;
      }
    } else {
      val = num(modal.querySelector(SEL.result) && modal.querySelector(SEL.result).value);
      if (!isFinite(val)) return;
    }

    var unklar = wrap.querySelector(SEL.unklar);
    if (unklar && unklar.checked) {
      unklar.checked = false;
      toggleUnklar(wrap, false);
    }
    var input = wrap.querySelector(SEL.length);
    if (input) {
      input.value = val;
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    closeModal(modal);
  }

  /* ---------- Delegierte Events ---------- */

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest(SEL.open))) {
      var wrap = wrapFor(t);
      if (wrap) { e.preventDefault(); openModal(wrap, t); }
      return;
    }
    if ((t = e.target.closest(SEL.close))) {
      var modal = t.closest(SEL.modal);
      if (modal) closeModal(modal);
      return;
    }
    if ((t = e.target.closest(SEL.apply))) {
      var modal2 = t.closest(SEL.modal);
      var wrap2 = modal2 && wrapFor(modal2);
      if (wrap2 && modal2) applyValue(wrap2, modal2, t.getAttribute('data-bek-apply'));
    }
  });

  document.addEventListener('input', function (e) {
    if (e.target.name === 'quantity' && e.target.form) {
      var quantityWrap = formWrap(e.target.form);
      if (quantityWrap) updateState(quantityWrap);
    }
    if (e.target.matches(SEL.length)) {
      var wrap = wrapFor(e.target);
      if (wrap) updateState(wrap);
      return;
    }
    if (e.target.matches(SEL.decke) || e.target.matches(SEL.hoehe)) {
      var modal = e.target.closest(SEL.modal);
      var wrap2 = modal && wrapFor(modal);
      if (wrap2 && modal) recalc(wrap2, modal);
      return;
    }
    if (e.target.matches(SEL.direct)) {
      var modal3 = e.target.closest(SEL.modal);
      if (modal3) showMsg(modal3, '');
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.name === 'quantity' && e.target.form) {
      var quantityWrap = formWrap(e.target.form);
      if (quantityWrap) updateState(quantityWrap);
    }
    if (e.target.matches(SEL.unklar)) {
      var wrap = wrapFor(e.target);
      if (wrap) toggleUnklar(wrap, e.target.checked);
    }
  });

  function modalFocusables(modal) {
    return Array.from(modal.querySelectorAll('button, input, select, textarea, a[href], [tabindex]')).filter(function (el) {
      return !el.disabled && el.tabIndex >= 0 && !el.closest('[hidden]') && el.getClientRects().length;
    });
  }

  document.addEventListener('keydown', function (e) {
    var open = document.querySelector(SEL.modal + ':not([hidden])');
    if (!open) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeModal(open); }
    if (e.key === 'Tab') {
      var items = modalFocusables(open);
      var first = items[0];
      var last = items[items.length - 1];
      if (!items.length) { e.preventDefault(); open.querySelector('[role="dialog"]').focus(); }
      else if (e.shiftKey && (document.activeElement === first || !open.contains(document.activeElement))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && (document.activeElement === last || !open.contains(document.activeElement))) {
        e.preventDefault(); first.focus();
      }
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    var open = document.querySelector(SEL.modal + ':not([hidden])');
    if (open && !open.contains(e.target)) {
      var first = modalFocusables(open)[0] || open.querySelector('[role="dialog"]');
      if (first) first.focus({ preventScroll: true });
    }
  });

  // Enter im Popup darf nicht das Produktformular absenden (solange das Popup
  // noch nicht nach <body> verschoben wurde) - stattdessen Wert uebernehmen.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var modal = e.target.closest && e.target.closest(SEL.modal);
    if (!modal) return;
    if (!e.target.matches(SEL.direct + ', ' + SEL.decke + ', ' + SEL.hoehe)) return;
    e.preventDefault();
    if (e.target.matches(SEL.direct)) {
      var btn = modal.querySelector('[data-bek-apply="direct"]');
      if (btn) btn.click();
    } else if (e.target.matches(SEL.decke) || e.target.matches(SEL.hoehe)) {
      var btn2 = modal.querySelector('[data-bek-apply="calc"]');
      if (btn2 && !btn2.disabled) btn2.click();
    }
  });

  // AjaxProduct owns the only purchase request. This synchronous event only
  // contributes validated configuration and the documented nested child line.
  document.addEventListener('bek:prepare-purchase', function (e) {
    var wrap = formWrap(e.target);
    if (!wrap || !e.detail) return;
    var purchase = e.detail;
    purchase.handled = true;
    var input = wrap.querySelector(SEL.length);
    var unklar = wrap.querySelector(SEL.unklar);
    if (unklar && unklar.checked) return;
    var c = conf(wrap);
    var val = num(input && input.value);
    if (!Number.isInteger(val) || val < c.min || val > c.max) {
      purchase.error = 'Bitte wählen Sie eine Rohrlänge zwischen ' + c.min + ' und ' + c.max + ' cm in ganzen Zentimetern.';
      return;
    }
    var sets = adapterQty(c, val);
    if (!sets) return;
    if (!adapterReady(c)) {
      purchase.error = 'Die benötigte Rohrverlängerung ist derzeit nicht bestellbar. Bitte kontaktieren Sie uns zur Abstimmung.';
      return;
    }
    purchase.main.properties._bek_rohr_sets = String(sets);
    purchase.main.properties._bek_rohr_adapter = c.adapterVariant;
    purchase.items.push({ id: c.adapterVariant, quantity: sets * purchase.main.quantity, parent_id: purchase.main.id, properties: { _bek_rohr_child: '1' } });
  });

  // Fallback fuer Browser ohne :has() - alte Befestigungsrohr-Optionszeile ausblenden.
  function hideLegacyOption(root) {
    (root || document).querySelectorAll('[data-handle^="befestigungsrohr"]').forEach(function (el) {
      var vw = el.closest('.variant-wrapper');
      if (vw) vw.style.display = 'none';
    });
  }
  var hasSupport = false;
  try { hasSupport = CSS.supports('selector(:has(*))'); } catch (e) {}
  if (!hasSupport) {
    document.addEventListener('DOMContentLoaded', function () { hideLegacyOption(document); });
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) hideLegacyOption(n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- Einstufige Familien-Farbwahl: Schwarz | Weiss Hochglanz | Weiss Matt ----------
     Buttons kommen aus snippets/product-family-selector-option.liquid ([data-bek-finish]).
     Die native Varianten-Optionszeile "Farbe"/"Farbe Kamin" wird versteckt; Klick auf einen
     Finish-Button schaltet die versteckte native Option um (Variantenwechsel ohne Reload). */

  try {
    document.head.insertAdjacentHTML('beforeend', '<style>' +
      '.product-section:has([data-bek-finish]) .variant-wrapper:has([data-handle="farbe"]),' +
      '.product-section:has([data-bek-finish]) .variant-wrapper:has([data-handle="farbe-kamin"])' +
      '{ display:none !important; }</style>');
  } catch (e) {}

  function syncFinishLabel(btn) {
    var wrap = btn.closest('.be-family-selector');
    var info = wrap && wrap.querySelector('.variant__label-info');
    if (info) info.textContent = '— ' + btn.textContent.trim();
  }

  function initFinish(root) {
    var scope = (root && root.querySelectorAll) ? root : document;
    scope.querySelectorAll('[data-bek-finish]').forEach(function (btn) {
      var section = btn.closest('.product-section');
      if (section && !section.dataset.bekFinishInit) {
        section.dataset.bekFinishInit = '1';
        ['farbe', 'farbe-kamin'].forEach(function (h) {
          section.querySelectorAll('[data-handle="' + h + '"]').forEach(function (el) {
            var vw = el.closest('.variant-wrapper');
            if (vw) vw.style.display = 'none';
          });
        });
      }
      if (btn.classList.contains('is-selected')) syncFinishLabel(btn);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bek-finish]');
    if (!btn) return;
    e.preventDefault();
    var section = btn.closest('.product-section') || document;
    var val = btn.getAttribute('data-bek-finish');

    var radios = section.querySelectorAll('input[data-variant-input]');
    var hit = null;
    radios.forEach(function (r) { if (r.value === val) hit = r; });
    if (hit) {
      if (!hit.checked) {
        hit.checked = true;
        hit.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      var sels = section.querySelectorAll('select[data-variant-input]');
      for (var i = 0; i < sels.length; i++) {
        var s = sels[i], has = false;
        for (var j = 0; j < s.options.length; j++) {
          if (s.options[j].value === val) { has = true; break; }
        }
        if (has) {
          if (s.value !== val) {
            s.value = val;
            s.dispatchEvent(new Event('change', { bubbles: true }));
          }
          break;
        }
      }
    }

    var group = btn.closest('.be-family-selector__options');
    if (group) {
      group.querySelectorAll('[data-bek-finish]').forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
        if (b.tagName === 'BUTTON') b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); /* a11y (Claude, 2026-09-28): Auswahl, keine Seite */
      });
    }
    syncFinishLabel(btn);
  });

  if (document.readyState !== 'loading') { initFinish(); }
  else { document.addEventListener('DOMContentLoaded', function () { initFinish(); }); }
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1 && (n.matches && n.matches('[data-bek-finish]') || n.querySelector && n.querySelector('[data-bek-finish]'))) {
          initFinish(n);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
